import React from 'react';

/**
 * Skeleton loader rosado para cards de producto.
 * Se muestra mientras llegan los datos del backend para evitar pantalla blanca
 * y dar sensación de carga rápida.
 */
export default function ProductSkeleton() {
  return (
    <div
      data-testid="product-skeleton"
      className="rounded-3xl overflow-hidden border border-pinky-100 bg-white"
    >
      <div className="aspect-square skeleton-pulse" />
      <div className="p-4 space-y-2">
        <div className="h-3 rounded-full skeleton-pulse w-2/3" />
        <div className="h-3 rounded-full skeleton-pulse w-5/6" />
        <div className="h-6 rounded-full skeleton-pulse w-1/3 mt-3" />
        <div className="h-9 rounded-full skeleton-pulse mt-3" />
      </div>
    </div>
  );
}
